import styled from "styled-components";

export const BeneficiosText = styled.p`
  color: #4d4d4d;
  font-size: 14px;
`;

export const SimulacaoValor = styled.span`
  margin-left: 16px;
  color: ${({ important, tema }) =>
    important ? tema.primaryColor : "#4D4D4D"} !important;
  font-weight: bold;
  font-size: ${({ important }) => (important ? "22px" : "14px")} !important;
`;

export const CheckBoxContainer = styled.div`
  margin-bottom: 16px;
  display: flex;
  align-items: center;

  .checkBoxText {
    font-size: 12px;
    font-weight: bold;
    margin-left: 4px;
    cursor: pointer;
  }
`;

export const BtnContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;

  width: 100%;

  button {
    width: 65%;
    background-color: transparent;
    font-weight: bold;
    font-size: 24px;
    border-radius: 4px;
    cursor: pointer;
    transition: 0.3s;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 16px;

    border: 2px solid ${({ tema }) => tema.primaryColor};
    color: ${({ tema }) => tema.primaryColor};

    &:hover {
      background-color: ${({ tema }) => tema.primaryColor};
      color: #ffffff;
    }

    &:first-child {
      width: 30%;
      border: 2px solid ${({ tema }) => tema.accent};
      color: ${({ tema }) => tema.accent};

      &:hover {
        background-color: ${({ tema }) => tema.accent};
        color: #ffffff;
      }
      &:disabled {
        background-color: #d1d1d1;
        color: #ffffff;
        border: 2px solid #d1d1d1;
        cursor: auto;
      }
    }

    &:disabled {
      background-color: #d1d1d1;
      color: #ffffff;
      border: 2px solid #d1d1d1;
      cursor: auto;
    }
  }

  @media (max-width: 768px) {
    display: flex;
    flex-direction: column;
    gap: 6px;

    button {
      width: 100% !important;
    }
  }
`;
